__turbopack_context__.v({
  "author": "styles-module-scss-module__fAUrWG__author",
  "company": "styles-module-scss-module__fAUrWG__company",
  "companyLogo": "styles-module-scss-module__fAUrWG__companyLogo",
  "icon": "styles-module-scss-module__fAUrWG__icon",
  "logo": "styles-module-scss-module__fAUrWG__logo",
  "noLogo": "styles-module-scss-module__fAUrWG__noLogo",
  "quote": "styles-module-scss-module__fAUrWG__quote",
  "testimonial": "styles-module-scss-module__fAUrWG__testimonial",
});
